/**
 * 	活动管理
 * 	  	>活动详情
 */
export default [
  {
    path: '/activityManagement',
    component: () => import(/* webpackChunkName: "Activity" */ '@/views/activityManagement/Index.vue'),
    meta: { requiresAuth: true, title: '活动管理', icon: '', role: true },
    children:
      [
        {
          path: '',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/activityManagement/ActivityManagement.vue'),
          meta: { title: '活动管理', role: true },
        },
        {
          path: 'managementDetail',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/activityManagement/managementDetail.vue'),
          meta: { title: '活动详情', role: true },
        }
      ],
  },
];